import React from 'react';
import { Button } from '../UI';
import classes from './ProjectDetailPage.module.css';

const ProjectForm = ({
  formData,
  errors,
  saving,
  onChange,
  onSubmit,
  onCancel,
  onDownloadAll,
  formatDate,
  project
}) => {
  return (
    <form onSubmit={onSubmit} className={classes.form}>
      <div className={classes.formGroup}>
        <label className={classes.label}>
          Project name <span className={classes.required}>*</span>
        </label>
        <input
          type="text"
          name="name"
          value={formData.name}
          onChange={onChange}
          className={`${classes.input} ${errors.name ? classes.inputError : ''}`}
          placeholder="Enter project name"
        />
        {errors.name && (
          <div className={classes.errorMessage}>{errors.name}</div>
        )}
      </div>

      <div className={classes.formGroup}>
        <label className={classes.label}>
          Location <span className={classes.required}>*</span>
        </label>
        <input
          type="text"
          name="location"
          value={formData.location}
          onChange={onChange}
          className={`${classes.input} ${errors.location ? classes.inputError : ''}`}
          placeholder="Enter location"
        />
        {errors.location && (
          <div className={classes.errorMessage}>{errors.location}</div>
        )}
      </div>

      <div className={classes.formGroup}>
        <label className={classes.label}>Creation date</label>
        <input
          type="date"
          name="createdAt"
          value={formData.createdAt}
          onChange={onChange}
          className={classes.input}
        />
      </div>

      <div className={classes.formGroup}>
        <label className={classes.label}>Notes</label>
        <textarea
          name="notes"
          value={formData.notes}
          onChange={onChange}
          className={classes.textarea}
          placeholder="Add notes about this project..."
          rows={6}
        />
      </div>

      <div className={classes.formGroup}>
        <label className={classes.label}>
          Status <span className={classes.required}>*</span>
        </label>
        <select
          name="status"
          value={formData.status}
          onChange={onChange}
          className={`${classes.select} ${errors.status ? classes.inputError : ''}`}
        >
          <option value="Preparation">Preparation</option>
          <option value="In progress">In progress</option>
          <option value="Delivered">Delivered</option>
        </select>
        {errors.status && (
          <div className={classes.errorMessage}>{errors.status}</div>
        )}
      </div>

      <div className={classes.formButtons}>
        <Button
          type="button"
          variant="secondary"
          onClick={onCancel}
          disabled={saving}
        >
          Cancel
        </Button>
        <Button
          type="submit"
          variant="primary"
          disabled={saving}
        >
          {saving ? 'Saving...' : 'Save Changes'}
        </Button>
      </div>

      <Button
        type="button"
        variant="primary"
        onClick={onDownloadAll}
        className={classes.downloadAllButton}
        fullWidth
      >
        Download all certificates
      </Button>
    </form>
  );
};

export default ProjectForm;

